function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import merge from 'deepmerge';
import Emitter from 'mitt';
import Sprite from './sprite';
import BrowserSymbol from './browser-symbol';
import defaultConfig from './browser-sprite.config';
import { arrayFrom, parse, moveGradientsOutsideSymbol, browserDetector as browser, getUrlWithoutFragment, updateUrls as _updateUrls, locationChangeAngularEmitter, evalStylesIEWorkaround } from './utils';
/**
 * Internal emitter events
 * @enum
 * @private
 */

var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = /*#__PURE__*/function (_Sprite) {
  _inherits(BrowserSprite, _Sprite);

  var _super = _createSuper(BrowserSprite);

  function BrowserSprite() {
    var _this;

    var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BrowserSprite);

    _this = _super.call(this, merge(defaultConfig, cfg));
    var emitter = Emitter();
    _this._emitter = emitter;
    _this.node = null;

    var _assertThisInitialize = _assertThisInitialized(_this),
        config = _assertThisInitialize.config;

    if (config.autoConfigure) {
      _this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () {
        return _this.updateUrls('#', baseUrl);
      });
    }

    var handleLocationChange = _this._handleLocationChange.bind(_assertThisInitialized(_this));

    _this._handleLocationChange = handleLocationChange; // Provide way to update sprite urls externally via dispatching custom window event

    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    } // Emit location change event in Angular automatically


    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    } // After sprite mounted


    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    }); // After symbol mounted into sprite

    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE() || browser.isEdge()) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
    return _this;
  }
  /**
   * @return {boolean}
   */


  _createClass(BrowserSprite, [{
    key: "_autoConfigure",

    /**
     * Automatically configure following options
     * - `syncUrlsWithBaseTag`
     * - `locationChangeAngularEmitter`
     * - `moveGradientsOutsideSymbol`
     * @param {Object} cfg
     * @private
     */
    value: function _autoConfigure(cfg) {
      var config = this.config;

      if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
        config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
      }

      if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
        config.locationChangeAngularEmitter = typeof window.angular !== 'undefined';
      }

      if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
        config.moveGradientsOutsideSymbol = browser.isFirefox();
      }
    }
    /**
     * @param {Event} event
     * @param {Object} event.detail
     * @param {string} event.detail.oldUrl
     * @param {string} event.detail.newUrl
     * @private
     */

  }, {
    key: "_handleLocationChange",
    value: function _handleLocationChange(event) {
      var _event$detail = event.detail,
          oldUrl = _event$detail.oldUrl,
          newUrl = _event$detail.newUrl;
      this.updateUrls(oldUrl, newUrl);
    }
    /**
     * Add new symbol. If symbol with the same id exists it will be replaced.
     * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
     * @fires Events#SYMBOL_MOUNT
     * @param {BrowserSpriteSymbol} symbol
     * @return {boolean} `true` - symbol was added, `false` - replaced
     */

  }, {
    key: "add",
    value: function add(symbol) {
      var sprite = this;

      var isNewSymbol = _get(_getPrototypeOf(BrowserSprite.prototype), "add", this).call(this, symbol);

      if (this.isMounted && isNewSymbol) {
        symbol.mount(sprite.node);

        this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
      }

      return isNewSymbol;
    }
    /**
     * Attach to existing DOM node
     * @param {string|Element} target
     * @return {Element|null} attached DOM Element. null if node to attach not found.
     */

  }, {
    key: "attach",
    value: function attach(target) {
      var _this2 = this;

      var sprite = this;

      if (sprite.isMounted) {
        return sprite.node;
      }
      /** @type Element */


      var node = typeof target === 'string' ? document.querySelector(target) : target;
      sprite.node = node; // Already added symbols needs to be mounted

      this.symbols.forEach(function (symbol) {
        symbol.mount(sprite.node);

        _this2._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
      }); // Create symbols from existing DOM nodes, add and mount them

      arrayFrom(node.querySelectorAll('symbol')).forEach(function (symbolNode) {
        var symbol = BrowserSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding

        sprite.add(symbol);
      });

      this._emitter.emit(Events.MOUNT, node);

      return node;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var config = this.config,
          symbols = this.symbols,
          _emitter = this._emitter;
      symbols.forEach(function (s) {
        return s.destroy();
      });

      _emitter.off('*');

      window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

      if (this.isMounted) {
        this.unmount();
      }
    }
    /**
     * @fires Events#MOUNT
     * @param {string|Element} [target]
     * @param {boolean} [prepend=false]
     * @return {Element|null} rendered sprite node. null if mount node not found.
     */

  }, {
    key: "mount",
    value: function mount() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config.mountTo;
      var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var sprite = this;

      if (sprite.isMounted) {
        return sprite.node;
      }

      var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
      var node = sprite.render();
      this.node = node;

      if (prepend && mountNode.childNodes[0]) {
        mountNode.insertBefore(node, mountNode.childNodes[0]);
      } else {
        mountNode.appendChild(node);
      }

      this._emitter.emit(Events.MOUNT, node);

      return node;
    }
    /**
     * @return {Element}
     */

  }, {
    key: "render",
    value: function render() {
      return parse(this.stringify());
    }
    /**
     * Detach sprite from the DOM
     */

  }, {
    key: "unmount",
    value: function unmount() {
      this.node.parentNode.removeChild(this.node);
    }
    /**
     * Update URLs in sprite and usage elements
     * @param {string} oldUrl
     * @param {string} newUrl
     * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
     */

  }, {
    key: "updateUrls",
    value: function updateUrls(oldUrl, newUrl) {
      if (!this.isMounted) {
        return false;
      }

      var usages = document.querySelectorAll(this.config.usagesToUpdate);

      _updateUrls(this.node, usages, "".concat(getUrlWithoutFragment(oldUrl), "#"), "".concat(getUrlWithoutFragment(newUrl), "#"));

      return true;
    }
  }, {
    key: "isMounted",
    get: function get() {
      return !!this.node;
    }
  }]);

  return BrowserSprite;
}(Sprite);

export { BrowserSprite as default };